/* 
SELECT CONCAT(CASE WHEN i.Code LIKE '[0-9]%' THEN '_' ELSE '' END + CAST(i.Code as varchar(max)), ': ', '"',  CAST(i.Code as varchar(max)), '"', ',')
FROM MuellerHomeowner.dbo.InspectionTypeGroups i
ORDER BY CASE WHEN i.Code LIKE '[0-9]%' THEN '_' ELSE '' END + CAST(i.Code as varchar(max))
*/

export const InspectionTypeCodes = {
  _1004_DESK_APPRAISAL: "1004_DESK_APPRAISAL",
  _1004_DESKTOP_70D_APPRAISAL: "1004_DESKTOP_70D_APPRAISAL",
  _1004_DESKTOP_70D_INSPECTION: "1004_DESKTOP_70D_INSPECTION",
  _1004_FHA_DESK_APPRAISAL: "1004_FHA_DESK_APPRAISAL",
  _1004_HYBRID_70H_INSPECTION: "1004_HYBRID_70H_INSPECTION",
  _1004D_APPRAISAL: "1004D_APPRAISAL",
  _1004D_APPRAISAL_COMPLETION: "1004D_APPRAISAL_COMPLETION",
  _1004P_APPRAISAL: "1004P_APPRAISAL",
  _1004P_INSPECT_ONLY: "1004P_INSPECT_ONLY",
  _1073_DESK_APPRAISAL: "1073_DESK_APPRAISAL",
  _1073_FHA_DESK_APPRAISAL: "1073_FHA_DESK_APPRAISAL",
  _2000_AP_FIELD_REVIEW: "2000_AP_FIELD_REVIEW",
  _2055_DESK_APPRAISAL: "2055_DESK_APPRAISAL",
  _2055_FHA_DESK_APPRAISAL: "2055_FHA_DESK_APPRAISAL",
  AUTO_CONVERT: "AUTO_CONVERT",
  AUTO_GLASS: "AUTO_GLASS",
  AUTO_POLICY_VERIFICATION: "AUTO_POLICY_VERIFICATION",
  BUILDERS_RISK: "BUILDERS_RISK",
  CALCONLY: "CALCONLY",
  CALCONLYCOMM: "CALCONLYCOMM",
  CALCONLYHV: "CALCONLYHV",
  CLAIM_VERIFY: "CLAIM_VERIFY",
  CLOSE_OUT: "CLOSE_OUT",
  COMM_EXT: "COMM_EXT",
  COMM_OCC_VERIFY: "COMM_OCC_VERIFY",
  COURSE_OF_CONSTRUCTION: "COURSE_OF_CONSTRUCTION",
  DATA_MINING: "DATA_MINING",
  DRIVEBY: "DRIVEBY",
  DRIVEBY_APPT: "DRIVEBY_APPT",
  DRIVEBY_SUPP: "DRIVEBY_SUPP",
  DRIVEBY_SUPP_APPT: "DRIVEBY_SUPP_APPT",
  ELITE_EXT_HIGH_VALUE_APPT_SUPP: "ELITE_EXT_HIGH_VALUE_APPT_SUPP",
  ELITE_HIGH_VALUE: "ELITE_HIGH_VALUE",
  ELITE_HIGH_VALUE_EXT_APPT: "ELITE_HIGH_VALUE_EXT_APPT",
  ELITE_HIGH_VALUE_SUPP: "ELITE_HIGH_VALUE_SUPP",
  ENDORSEMENT: "ENDORSEMENT",
  EXT_DIAG_ONLY: "EXT_DIAG_ONLY",
  EXT_OCC_COND: "EXT_OCC_COND",
  EXT_PHOTO: "EXT_PHOTO",
  EXT_SUPP_ONLY: "EXT_SUPP_ONLY",
  EXTERIOR: "EXTERIOR",
  EXTERIOR_APPT: "EXTERIOR_APPT",
  EXTERIOR_DESKTOP: "EXTERIOR_DESKTOP",
  EXTERIOR_DESKTOP_SUPP: "EXTERIOR_DESKTOP_SUPP",
  EXTERIOR_SUPP: "EXTERIOR_SUPP",
  EXTERIOR_SUPP_APPT: "EXTERIOR_SUPP_APPT",
  FANNIE_MAE_1004_HYBRID: "FANNIE_MAE_1004_HYBRID",
  FARM: "FARM",
  FEMA: "FEMA",
  FOUR_POINT: "FOUR_POINT",
  FREDDIE_MAC_70H: "FREDDIE_MAC_70H",
  FULL_COMM: "FULL_COMM",
  HIGH_VALUE: "HIGH_VALUE",
  HIGH_VALUE_EXT_APPT: "HIGH_VALUE_EXT_APPT",
  HIGH_VALUE_EXT_SUPP: "HIGH_VALUE_EXT_SUPP",
  HIGH_VALUE_EXTERIOR: "HIGH_VALUE_EXTERIOR",
  HIGH_VALUE_INTERMEDIATE: "HIGH_VALUE_INTERMEDIATE",
  HIGH_VALUE_NO_RC: "HIGH_VALUE_NO_RC",
  HOME_CHECKUP: "HOME_CHECKUP",
  HV_SHORT: "HV_SHORT",
  INSPECTION_ONLY_COMPLETION_REPORT: "INSPECTION_ONLY_COMPLETION_REPORT",
  INT_EXT: "INT_EXT",
  INT_EXT_NO_RC: "INT_EXT_NO_RC",
  INT_EXT_ONLY: "INT_EXT_ONLY",
  INT_EXT_ONLY_SP: "INT_EXT_ONLY_SP",
  INT_EXT_SINK: "INT_EXT_SINK",
  INT_EXT_SP: "INT_EXT_SP",
  INT_PHOTO: "INT_PHOTO",
  INTERIOR_DESKTOP: "INTERIOR_DESKTOP",
  INTERIOR_DESKTOP_REO: "INTERIOR_DESKTOP_REO",
  INTERIOR_DESKTOP_SUPP: "INTERIOR_DESKTOP_SUPP",
  JOBSITE: "JOBSITE",
  LEND_COMM_INT_NODIAG: "LEND_COMM_INT_NODIAG",
  LENDER_COMM_INTERIOR: "LENDER_COMM_INTERIOR",
  LENDER_COMM_PROPERTY: "LENDER_COMM_PROPERTY",
  LENDER_INIT_QC: "LENDER_INIT_QC",
  LENDER_INTERIOR: "LENDER_INTERIOR",
  LENDER_INTERIOR_DIAG: "LENDER_INTERIOR_DIAG",
  LENDER_INTERIOR_RC: "LENDER_INTERIOR_RC",
  LENDER_OCCUP: "LENDER_OCCUP",
  LENDER_PROPERTY: "LENDER_PROPERTY",
  LENDER_PROPERTY_AVM: "LENDER_PROPERTY_AVM",
  LENDER_QC: "LENDER_QC",
  LPP: "LPP",
  M_C_SURVEY: "M_C_SURVEY",
  MAILER: "MAILER",
  OCC_VERIFY: "OCC_VERIFY",
  OFF_LEASE_VHCL: "OFF_LEASE_VHCL",
  PHONE_SURVEY: "PHONE_SURVEY",
  RAPID: "RAPID",
  REC_CHECK: "REC_CHECK",
  SHORT_COMM: "SHORT_COMM",
  SHORT_COMM_LIABILITY: "SHORT_COMM_LIABILITY",
  SHORT_COMM_PROPERTY: "SHORT_COMM_PROPERTY",
  SHORT_FARM: "SHORT_FARM",
  SUPP_ONLY: "SUPP_ONLY",
  TELESTREET_MV: "TELESTREET_MV",
  VIRTUAL: "VIRTUAL",
  WEB_RESPONSE: "WEB_RESPONSE",
  WIND_MIT: "WIND_MIT",
  WIND_MIT_FOUR_POINT: "WIND_MIT_FOUR_POINT",
  WIND_MIT_REM: "WIND_MIT_REM",
  WIND_MIT_RETAIL: "WIND_MIT_RETAIL",
};